export default "__VITE_ASSET__b87078c7__"